import TYPES from '@/modules/shared/types';

// Domain
import { AllianzPolicyIssuanceStatusRepository } from '../../domain/repository';
import { AllianzPolicyIssuanceStatusEntity }
  from '../../domain/entities/allianz-policy-issuance-status-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzPolicyIssuanceStatusHttpRepository
implements AllianzPolicyIssuanceStatusRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/customer-allianz-policy-issuance-status/`;

  get(): Promise<AllianzPolicyIssuanceStatusEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'GET', undefined, 0)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
